import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useEffect, useState } from 'react';
import { IonHeader, IonContent, IonPage, IonToolbar } from '@ionic/react';
import Toolbar from '../components/common/Toolbar';
import AlertBanner from '../components/common/AlertBanner';
import Typography from '../components/common/Typography';

interface PrivacyProps {}

const Privacy: React.FC<PrivacyProps> = (props) => {
  const [markdown, setMarkdown] = useState<string>('');

  useEffect(() => {
    fetch('/privacy.md')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to load privacy policy');
        }
        return res.text();
      })
      .then(setMarkdown)
      .catch(() => {
        setMarkdown(
          'Sorry, the privacy policy could not be loaded at this time.'
        );
      });
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <Toolbar showBackButton showMenu />
      </IonHeader>
      <IonContent>
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '32px 16px' }}>
          <ReactMarkdown>{markdown}</ReactMarkdown>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Privacy;
